import {
    ApiClientSettings,
    DEFAULT_BRAND_FONT_FAMILY,
} from '@storefronts/common-types'
import { createContext } from 'react'

export type CustomizationContext = ApiClientSettings

export const DefaultCustomizationContext: CustomizationContext = {
    primaryFontFamily: {
        name: DEFAULT_BRAND_FONT_FAMILY,
        files: [
            {
                type: 'GOOGLE',
                src: DEFAULT_BRAND_FONT_FAMILY,
                weight: 400,
                style: 'normal',
            },
        ],
    },
    secondaryFontFamily: {
        name: DEFAULT_BRAND_FONT_FAMILY,
        files: [
            {
                type: 'GOOGLE',
                src: DEFAULT_BRAND_FONT_FAMILY,
                weight: 400,
                style: 'normal',
            },
        ],
    },
    primaryCtaTextColor: '#FFFFFF',
    primaryCtaFillColor: '#000000',
    accentFillColor: '#000000',
    accentTextColor: '#FFFFFF',
    primaryPageFillColor: '#FFFFFF',
    primaryPageTextColor: '#000000',
    secondaryCtaTextColor: '#FFFFFF',
    secondaryCtaFillColor: '#000000',
    tertiaryCtaTextColor: null,
    tertiaryCtaFillColor: null,
    secondaryDiscountColor: '#FFFFFF',
    primaryDiscountColor: '#CC0C39',
    buttonBorderRadiusStyle: 'ROUNDED',
    mediaBorderRadiusStyle: 'ROUNDED',
    fullBleedMedia: true,
    reviewStarColorOverride: null,
    iconColorOverride: null,
    borderColorOverride: null,
    headerBorderEnabled: true,
    headerVerifiedBadgeEnabled: true,
    headerLogoSize: 'MEDIUM',
    headerLogoAlignment: 'CENTER',
    cartIconStyle: 'BAG',
    brandBenefits: [],
    typographyRoleOverrides: [],
    sellingPlanGroupIds: [],
    subscriptionAppId: null,
    subscriptionButtonText: null,
    displaySubscriptionOptions: true,
    displayCartSubscriptionOptions: true,
    defaultPurchaseOption: 'ONE_TIME',
    displayPoweredByFooter: true,
    freeShippingEnabled: false,
    freeShippingMinCartAmount: 0,
    freeShippingTypicalCost: null,
    freeShippingCostInSubtotal: false,
    hideUnavailableProducts: false,
    autoExpandCart: false,
    displayShopPayButtons: false,
    desktopRedirectEnabled: false,
    desktopRedirectUrl: null,
    globalPromotion: null,
    globalPromotionMode: 'MANUAL',
    promotionPrecedence: 'GLOBAL',
    scheduledPromotions: [],
    clientConsentSetting: null,
    customPriceSettings: [],
    productFamiliesEnabled: false,
}

export const CustomizationContext = createContext<CustomizationContext>(
    DefaultCustomizationContext,
)
